export default __webpack_public_path__ + "static/media/colocado-8-thumb.55fb51c6.jpg";